import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
const ModalCovid = (props) => {
  // info prof Santer

  const infoProf = sessionStorage.getItem("healthId");

  const { show, Toggle } = props;

  {
    /* Modal 2*/
  }
  const [showmodal2, setshowmodal2] = useState(false);
  const handleClose2 = () => setshowmodal2(false);
  const handleShow2 = () => {
    setshowmodal2(true);
    setshowmodal3(false);
    setshowmodal4(false);
    Toggle();
  };

  {
    /* Modal 3*/
  }
  const [showmodal3, setshowmodal3] = useState(false);
  const handleClose3 = () => setshowmodal3(false);
  const handleShow3 = () => {
    setshowmodal3(true);
    Toggle();
  };

  {
    /* Modal 4*/
  }
  const [showmodal4, setshowmodal4] = useState(false);
  const handleClose4 = () => {
    // setshowmodal4(false);
    window.location.replace("/searchrdv");
  };
  const handleShow4 = () => {
    setshowmodal4(true);
    setshowmodal3(false);
  };

  const labo = JSON.parse(sessionStorage.getItem("Laboratory"));

  return (
    <>
      {/* Modal 1 */}
      <Modal show={show} onHide={Toggle}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={props.Toggle}
          />
          <h6 style={{ marginTop: "55px", marginBottom: "18px" }}>
            Êtes-vous présentement en quarantaine pour une ou plusieurs des
            raisons suivantes?
          </h6>
          <ul className="ml-3">
            <li>Vous avez été diagnostiqué positif à la COVID-19</li>
            <li>Vous êtes de retour d’un voyage à l’extérieur du Canada</li>
            <li>
              Vous êtes en attente d'un résultat de test de dépistage pour la
              COVID-19
            </li>
            <li>Toute autre raison</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={handleShow2}>
            Oui
          </Button>

          <Button className="mr-auto" variant="danger" onClick={handleShow3}>
            Non
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal 2*/}
      <Modal show={showmodal2} onHide={handleClose2}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={handleClose2}
          />
          <p style={{ marginTop: " 55px", textAlign: "justify" }}>
            En raison de votre situation actuelle, Doclic n'est pas en mesure de
            vous offrir ses services. pour toute information n'hésitez pas à
            nous-contacter sur le numéro <br />
            <b>{labo && labo.tel}</b>.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Link to={infoProf && infoProf.speciality ? "/home" : "/"}>
            <Button className="mr-auto" variant="danger" onClick={handleClose2}>
              Fermer
            </Button>
          </Link>
        </Modal.Footer>
      </Modal>

      {/* Modal 3*/}
      <Modal show={showmodal3} onHide={handleClose3}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={handleClose3}
          />
          <h6 style={{ marginTop: "55px", marginBottom: "18px" }}>
            Afin de vous orienter vers le point de service approprié à votre
            situation, avez-vous l'un des symptômes suivants?
          </h6>
          <ul className="ml-3">
            <li>Fièvre</li>
            <li>
              Perte de l’odorat (anosmie) sans congestion nasale, avec ou sans
              perte de goût
            </li>
            <li>Toux (récente ou chronique exacerbée)</li>
            <li>
              Difficultés respiratoires et/ou sensation d’essoufflement et/ou
              étouffement même au repos
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={handleShow2}>
            Oui
          </Button>

          <Button className="mr-auto" variant="danger" onClick={handleShow4}>
            Non
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal 4*/}
      <Modal show={showmodal4} onHide={handleClose4}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={handleClose4}
          />
          <h6 style={{ marginTop: "55px", marginBottom: "18px" }}>
            Afin de vous orienter vers le point de service approprié à votre
            situation, avez-vous
            <span style={{ fontWeight: "bold" }}> au moins 2 </span>des
            symptômes suivants?
          </h6>
          <ul className="ml-3">
            <li>
              Douleurs musculaires généralisées non reliées à un effort physique{" "}
            </li>
            <li>Maux de tête (récents ou exacerbés)</li>
            <li>Mal de gorge (récent ou exacerbé) </li>
            <li>
              Maux de ventre et/ou nausées (maux de cœur) et/ou vomissements
              et/ou diarrhée
            </li>
            <li>Perte d’appétit importante</li>
            <li>Fatigue intense (récente ou exacerbée)</li>
          </ul>
          <span style={{ fontWeight: "bold", marginLeft: "25px" }}>OU</span>
          <h6 style={{ marginTop: "15px", marginBottom: "18px" }}>
            Dans les derniers 14 jours, été en contact avec quelqu'un qui a été
            testé positif à la COVID-19?
          </h6>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={handleShow2}>
            Oui
          </Button>

          <Button className="mr-auto" variant="danger" onClick={handleClose4}>
            Non
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalCovid;
